import { render, staticRenderFns } from "./schoolHKM.vue?vue&type=template&id=f39cfe2a&scoped=true&"
import script from "./schoolHKM.vue?vue&type=script&lang=js&"
export * from "./schoolHKM.vue?vue&type=script&lang=js&"
import style0 from "./schoolHKM.vue?vue&type=style&index=0&id=f39cfe2a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f39cfe2a",
  null
  
)

export default component.exports